/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ originalAudio: NonNullable<unknown>, adAudio: NonNullable<unknown> }} Audio_Embed_Export_Scan_Complete_ToastInputs */

const en_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scan complete. Found ${i?.originalAudio} original audio track(s) and ${i?.adAudio} AD audio track(s).`)
};

const fr_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analyse terminée. Piste(s) audio originale(s) ${i?.originalAudio} et piste(s) audio AD ${i?.adAudio} trouvées.`)
};

const de_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scan abgeschlossen. Original-Audiospur(en) ${i?.originalAudio} und AD-Audiospur(en) ${i?.adAudio} gefunden.`)
};

const it_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scansione completata. Trovate ${i?.originalAudio} tracce audio originali e ${i?.adAudio} tracce audio AD.`)
};

const ru_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сканирование завершено. Обнаружены оригинальные аудиодорожки ${i?.originalAudio} и аудиодорожки ${i?.adAudio} AD.`)
};

const es_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escaneo completado. Se encontraron ${i?.originalAudio} pista(s) de audio original(es) y ${i?.adAudio} pista(s) de audio AD.`)
};

const zh_cn2_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`扫描完成。找到${i?.originalAudio}原始音轨和${i?.adAudio} AD音轨。`)
};

const ja_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スキャンが完了しました。オリジナル音声トラック${i?.originalAudio}とAD音声トラック${i?.adAudio}が見つかりました。`)
};

const hi_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्कैन पूरा हुआ। ${i?.originalAudio} मूल ऑडियो ट्रैक और ${i?.adAudio} विज्ञापन ऑडियो ट्रैक मिले।`)
};

const pt_pt2_audio_embed_export_scan_complete_toast = /** @type {(inputs: Audio_Embed_Export_Scan_Complete_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Análise concluída. Encontradas ${i?.originalAudio} faixas de áudio originais e ${i?.adAudio} faixas de áudio AD.`)
};

/**
* | output |
* | --- |
* | "Scan complete. Found {originalAudio} original audio track(s) and {adAudio} AD audio track(s)." |
*
* @param {Audio_Embed_Export_Scan_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan_complete_toast = /** @type {((inputs: Audio_Embed_Export_Scan_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Scan_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "de") return de_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "it") return it_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "ru") return ru_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "es") return es_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "ja") return ja_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "hi") return hi_audio_embed_export_scan_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_scan_complete_toast(inputs)
	return en_audio_embed_export_scan_complete_toast(inputs)
});